var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userDiv === 0)?_c('div',[_c('SuperAdmin')],1):(_vm.userDiv === 1)?_c('div',[_c('Admin')],1):(_vm.userDiv === 2)?_c('div',[_c('User')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b24775ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/SubHeader.vue
// module id = null
// module chunks = 